export class EntityFeatureInformation {
    entityId: string;
    allowInventory: boolean;
    allowShopping: boolean;
    allowInvoicing: boolean;
}